import { motion } from 'framer-motion';
import styles from './Question.module.css';

import logo from '../../assets/images/logo.png';

export function Question({ title, questionFontSize }) {
  const titleArr = title.split('\n').map((el) => el.replace('\r', ''));

  const wiggle = [0, 1, -1, 0, 2, 1, -2, 0, -1, 2, 1, 0];

  return (
    <div className={styles.questionWrapper}>
      <motion.img
        initial={{ y: '-35rem' }}
        animate={{ y: '0rem' }}
        transition={{ duration: 1 }}
        src={logo}
        alt="logo"
        className={styles.logo}
      />

      <div className={styles.questionBlock}>
        {titleArr[0] && (
          <motion.div
            initial={{ scale: 20.6, opacity: 0, rotate: 0 }}
            animate={{
              scale: 1,
              opacity: 1,
              rotate: wiggle,
              transition: {
                opacity: { duration: 0.8 },
                scale: { duration: 1.27, ease: 'easeIn' },
                rotate: { duration: 2.5, repeat: Infinity },
              },
            }}
            className={styles.firstLine}
            style={{
              fontSize: `${questionFontSize}rem`,
              lineHeight: `${questionFontSize}rem`,
            }}
          >
            <div>{titleArr[0]}</div>
          </motion.div>
        )}
        {titleArr[1] && (
          <motion.div
            initial={{ scale: 20.6, opacity: 0, rotate: 0 }}
            animate={{
              scale: 1,
              opacity: 1,
              rotate: wiggle,
              transition: {
                opacity: { duration: 0.8, delay: 1.27 },
                scale: { duration: 1.27, ease: 'easeIn', delay: 1.27 },
                rotate: { duration: 6, repeat: Infinity, delay: 0.5 },
              },
            }}
            className={styles.secondLine}
            style={{
              fontSize: `${questionFontSize}rem`,
              lineHeight: `${questionFontSize}rem`,
            }}
          >
            <div>{titleArr[1]}</div>
          </motion.div>
        )}
        {titleArr[2] && (
          <motion.div
            initial={{ scale: 20.6, opacity: 0, rotate: 0 }}
            animate={{
              scale: 1,
              opacity: 1,
              rotate: wiggle,
              transition: {
                opacity: { duration: 0.8, delay: 2.54 },
                scale: { duration: 1.27, ease: 'easeIn', delay: 2.54 },
                rotate: { duration: 6, repeat: Infinity, delay: 1 },
              },
            }}
            className={styles.thirdLine}
            style={{
              fontSize: `${questionFontSize}rem`,
              lineHeight: `${questionFontSize}rem`,
            }}
          >
            <div>{titleArr[2]}</div>
          </motion.div>
        )}
        {titleArr[3] && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              transition: {
                opacity: { duration: 0.8, delay: 4 },
              },
            }}
            className={styles.fourthLine}
            style={{
              fontSize: `${questionFontSize}rem`,
              lineHeight: `${questionFontSize}rem`,
            }}
          >
            <div>{titleArr[3]}</div>
          </motion.div>
        )}
      </div>

      <motion.div
        initial={{ scale: 0, rotate: 0 }}
        animate={{ scale: 1, rotate: wiggle }}
        transition={{
          scale: { duration: 0.33, delay: 5.38 },
          rotate: { duration: 2.5, repeat: Infinity, delay: 1.4 },
        }}
        className={`${styles.questBlock} ${styles.one}`}
      >
        <div className={`${styles.quest} ${styles.one}`}>?</div>
      </motion.div>

      <motion.div
        initial={{ scale: 0, rotate: 0 }}
        animate={{ scale: 1.36, rotate: wiggle }}
        transition={{
          scale: { duration: 0.33, delay: 5.21 },
          rotate: { duration: 2.5, repeat: Infinity, delay: 1.6 },
        }}
        className={`${styles.questBlock} ${styles.two}`}
      >
        <div className={`${styles.quest} ${styles.two}`}>?</div>
      </motion.div>

      <motion.div
        initial={{ scale: 0, rotate: 0 }}
        animate={{ scale: 1, rotate: wiggle }}
        transition={{
          scale: { duration: 0.33, delay: 5.08 },
          rotate: { duration: 2.5, repeat: Infinity, delay: 1.1 },
        }}
        className={`${styles.questBlock} ${styles.three}`}
      >
        <div className={`${styles.quest} ${styles.three}`}>?</div>
      </motion.div>

      <motion.div
        initial={{ scale: 0, rotate: 0 }}
        animate={{ scale: 1, rotate: wiggle }}
        transition={{
          scale: { duration: 0.33, delay: 5.08 },
          rotate: { duration: 2.5, repeat: Infinity, delay: 1.3 },
        }}
        className={`${styles.questBlock} ${styles.four}`}
      >
        <div className={`${styles.quest} ${styles.four}`}>?</div>
      </motion.div>

      <motion.div
        initial={{ scale: 0, rotate: 0 }}
        animate={{ scale: 1.36, rotate: wiggle }}
        transition={{
          scale: { duration: 0.33, delay: 5.38 },
          rotate: { duration: 2.5, repeat: Infinity, delay: 1.5 },
        }}
        className={`${styles.questBlock} ${styles.five}`}
      >
        <div className={`${styles.quest} ${styles.five}`}>?</div>
      </motion.div>

      <motion.div
        initial={{ scale: 0, rotate: 0 }}
        animate={{ scale: 1, rotate: wiggle }}
        transition={{
          scale: { duration: 0.33, delay: 5.21 },
          rotate: { duration: 2.5, repeat: Infinity, delay: 1.2 },
        }}
        className={`${styles.questBlock} ${styles.six}`}
      >
        <div className={`${styles.quest} ${styles.six}`}>?</div>
      </motion.div>
    </div>
  );
}
